import { SBOM_PORTAL } from '../../../../shared/featureFlags/flagNames';
import { Action, ResourceType } from '../../../../typings/permissions';
import { useParams } from '../../../contexts/RouterContext';
import { useIsFeatureEnabled } from '../../../helpers/features/featureFlags';
import useHasPermission from '../../../shared/permissions/useHasPermission';
import { isReleaseGroupScope, type ReportsV3Params } from '../types';

import { useReportType } from './useReportType';

/**
 * Whether the current user can publish the current report to the SBOM portal.
 *
 * Publishing is only available for SBOM reports at the release group level, and
 * requires both the `SBOM_PORTAL` feature flag and the "manage organization
 * portal reports" permission.
 */
export function useCanPublishSbom(): boolean {
  const reportType = useReportType();
  const params = useParams<ReportsV3Params>();
  const isReleaseGroup = isReleaseGroupScope(params);
  const isSbomPortalEnabled = useIsFeatureEnabled(SBOM_PORTAL);
  const hasPermission = useHasPermission();
  const canManagePortalReports = hasPermission({
    resourceType: ResourceType.OrganizationPortalReports,
    action: Action.Manage,
  });

  return reportType === 'sbom' && isReleaseGroup && isSbomPortalEnabled && canManagePortalReports;
}
